import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b0f96da"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=5b0f96da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports